export default __webpack_public_path__ + "static/media/njdeplogo.078a5e07.png";